import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled(RouterLink)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
`;
